// Находим элемент spark-pdp на странице
const sparkPdpElement = document.querySelector('spark-pdp');

const checkShadowDom = setInterval(() => {
  if (sparkPdpElement?.shadowRoot) {
    console.log('Shadow DOM detected');

    const shadowRoot = sparkPdpElement.shadowRoot;

    // Останавливаем таймер, так как shadowRoot найден
    clearInterval(checkShadowDom);

    // Настраиваем MutationObserver для отслеживания новых элементов внутри shadowRoot
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
           // console.log('New element added in shadow DOM:', node);

            // Проверяем, есть ли стили, и добавляем их, если еще не добавлены
            if (!shadowRoot.querySelector('style')) {
              const style = document.createElement('style');
              style.textContent = `
                .input-field p {
                  font-size: 16px;
                  line-height: 22px;
                  font-family: Avenir Next;
                  letter-spacing: .35px;
                  color: #000;
                  opacity: 1;
                  text-transform: uppercase;
                  margin-bottom: 6px;
                }
                .input-field select {
                  font-family: Avenir Next !important;
                  color:#000 !important;
                  font-size: 13px !important;
                  line-height: 18px !important;
                  letter-spacing: .1px !important;
                  max-width: 274px !important;
                  width: 100% !important;
                  margin: 0 !important;
                  padding: 0 !important;
                  text-align: center !important;
                  height: 40px !important;
                  -moz-appearance: none !important;
                  -webkit-appearance: none !important;
                   appearance: none !important;
                   -o-appearance: none !important;
                  max-width: 274px !important;
                  border: 1px solid #727272 !important;
                  text-transform:uppercase !important;
                }
                .input-field select::-ms-expand {
                  display: none none !important;
                }
               
              `;
              shadowRoot.appendChild(style);
              //console.log('Styles added to shadow DOM');
            }
          }
        });
      }
    });

    // Начинаем наблюдать за изменениями внутри shadowRoot
    observer.observe(shadowRoot, { childList: true, subtree: true });
  }
}, 100); // Проверка каждые 100 мс



 /*.spark-table-legacy thead tr {
                background:none !important;
                }
                .spark-pdp .product-variant-table {
                  border: 1px solid #000 !important;
                }
                .spark-table-legacy thead tr th {
                  padding:40px 0px !important;
                  border-bottom:1px solid #000;
                   font-family: Avenir Next !important;
                  color:#000 !important;
                  font-size: 13px !important;
                  line-height: 18px !important;
                  letter-spacing: .1px !important;
                }
                .spark-table-legacy.highlight>tbody>tr {
                  background:transparent !important;
                }
                .spark-pdp .product-variant-table td.variant--image img.variant--image--small {
                  width:71px !important;
                  height:96px !important;
                }
                .spark-table-legacy.striped>tbody>tr>td {
                  padding:20px 0px !important;
                }*/
